import React, { Fragment, useEffect } from "react";
import AppRouter from "./routers/AppRouter";
import Enviroment from "./components/commons/enviroment";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <Fragment>
        <Enviroment />
        <AppRouter />
    </Fragment>
  );
}

export default App;
